export default __webpack_public_path__ + "static/aws-graph-5b84098a4e6a49d54ee29257daff0699.png";